'use client';

import * as Counterscale from '@counterscale/tracker';

// Phase 7 cutover (2026-05-07): one worker now serves both
// motoringobsession.com (prod) and mtrobs.com (staging). siteId + reporter
// URL are picked per host so the dashboards stay separate and beacons hit
// a same-eTLD+1 endpoint (better ad-blocker resilience).
function pickSiteId() {
  if (process.env.NODE_ENV !== 'production') return 'mtrobs-dev';
  if (typeof window === 'undefined') return 'motoringobsession';
  return window.location.hostname === 'mtrobs.com'
    ? 'mtrobs-staging'
    : 'motoringobsession';
}
function pickReporterUrl() {
  if (typeof window === 'undefined')
    return 'https://analytics.motoringobsession.com/collect';
  return window.location.hostname === 'mtrobs.com'
    ? 'https://analytics.mtrobs.com/collect'
    : 'https://analytics.motoringobsession.com/collect';
}

let initialized = false;

export function initCounterscale() {
  if (initialized || typeof window === 'undefined') return;
  if (process.env.NODE_ENV !== 'production') return;
  initialized = true;
  Counterscale.init({
    siteId: pickSiteId(),
    reporterUrl: pickReporterUrl(),
    autoTrackPageviews: false,
  });
}

export function trackPageview(url?: string) {
  if (!initialized) return;
  Counterscale.trackPageview(url ? { url } : undefined);
}

export function trackEvent(name: string) {
  if (!initialized) return;
  Counterscale.trackPageview({ url: `/_event/${name}` });
}

// Nav clicks: always fire `nav_<name>`; when the click happens on the homepage
// also fire `home_nav_<name>`, so "where do people go from /" is answerable
// without per-visitor tracking. Names stay low-cardinality (tab / model slugs).
export function trackNavEvent(name: string) {
  trackEvent(`nav_${name}`);
  if (typeof window !== 'undefined' && window.location.pathname === '/') {
    trackEvent(`home_nav_${name}`);
  }
}

// The tracker sends its beacon over plain XHR (a /cache token fetch then
// /collect) — no sendBeacon/keepalive — so an immediate navigation (e.g. an
// OAuth redirect) cancels it and the event is lost. Fire the event, then give
// the XHRs a short window to land before the caller navigates. Best-effort:
// good enough for directional funnel counts. No-op wait when not initialized.
export async function trackEventBeforeNav(
  name: string,
  ms = 250,
): Promise<void> {
  if (!initialized) return;
  trackEvent(name);
  await new Promise((resolve) => setTimeout(resolve, ms));
}
